import React, {Component} from 'react';
import {connect} from 'react-redux';

class TotalMinExposure extends Component {
    getClassName(value) {
        return Number(value) > 100 ? 'text-dark-red' : '';
    }
    render() {
        const {stackNumber, stacking} = this.props;
        const value = stacking.getTotalMinExposureOfCheckedActiveTeamsInStackNumber(stackNumber);

        return (
            <div className="form-inline justify-content-end">
                <strong className="form-text">Total min exp:</strong>
                <span className={this.getClassName(value)}>{value}%</span>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;

    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(TotalMinExposure);
